(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hibana-cookie-consent-v2"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.getElementById('hibana-cookie-consent');
    if (!root || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

    const banner = root.querySelector('[data-hibana-banner]');
    const dialog = root.querySelector('[data-hibana-dialog]');
    const modalToggle = root.querySelector('[data-hibana-modal-toggle]');
    const status = root.querySelector('[data-hibana-status]');
    const preferencesInput = root.querySelector('[data-hibana-preferences]');
    const analyticsInput = root.querySelector('[data-hibana-analytics]');
    const marketingInput = root.querySelector('[data-hibana-marketing]');
    const gtmId = root.dataset.gtmId;
    let hasDecision = false;
    let gtmLoaded = false;
    let consentApiReady = false;
    let currentConsent = { preferences: '', analytics: '', marketing: '' };

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('consent', 'default', {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: 'denied',
      functionality_storage: 'denied',
      personalization_storage: 'denied',
      security_storage: 'granted',
      wait_for_update: 500
    });

    const loadGtm = () => {
      if (gtmLoaded || !gtmId) return;
      gtmLoaded = true;
      window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`;
      document.head.appendChild(script);
    };

    const applyConsent = (consent) => {
      const preferencesGranted = consent.preferences === true || consent.preferences === 'yes';
      const analyticsGranted = consent.analytics === true || consent.analytics === 'yes';
      const marketingGranted = consent.marketing === true || consent.marketing === 'yes';
      window.gtag('consent', 'update', {
        ad_storage: marketingGranted ? 'granted' : 'denied',
        ad_user_data: marketingGranted ? 'granted' : 'denied',
        ad_personalization: marketingGranted ? 'granted' : 'denied',
        analytics_storage: analyticsGranted ? 'granted' : 'denied',
        functionality_storage: preferencesGranted ? 'granted' : 'denied',
        personalization_storage: preferencesGranted ? 'granted' : 'denied',
        security_storage: 'granted'
      });
      window.dataLayer.push({
        event: 'hibana_consent_updated',
        hibana_preferences_consent: preferencesGranted,
        hibana_analytics_consent: analyticsGranted,
        hibana_marketing_consent: marketingGranted
      });
      if (analyticsGranted || marketingGranted) loadGtm();
    };

    const syncControls = (consent) => {
      preferencesInput.checked = consent.preferences === 'yes';
      analyticsInput.checked = consent.analytics === 'yes';
      marketingInput.checked = consent.marketing === 'yes';
    };

    const showBanner = () => {
      banner.hidden = false;
    };

    const hideBanner = () => {
      banner.hidden = true;
    };

    const openPreferences = () => {
      if (!consentApiReady) return;
      syncControls(currentConsent);
      banner.hidden = true;
      status.textContent = '';
      modalToggle.checked = true;
    };

    const closePreferences = () => {
      modalToggle.checked = false;
      if (hasDecision) hideBanner();
      else showBanner();
    };

    const saveConsent = (consent) => {
      if (!consentApiReady) return;
      status.textContent = '';
      window.Shopify.customerPrivacy.setTrackingConsent(consent, () => {
        hasDecision = true;
        currentConsent = consent;
        applyConsent(consent);
        modalToggle.checked = false;
        hideBanner();
      });
    };

    const acceptAll = () => saveConsent({ preferences: true, analytics: true, marketing: true });
    const rejectOptional = () => saveConsent({ preferences: false, analytics: false, marketing: false });

    root.querySelector('[data-hibana-accept]').addEventListener('click', acceptAll);
    root.querySelector('[data-hibana-dialog-accept]').addEventListener('click', acceptAll);
    root.querySelector('[data-hibana-reject]').addEventListener('click', rejectOptional);
    root.querySelector('[data-hibana-dialog-reject]').addEventListener('click', rejectOptional);
    root.querySelector('[data-hibana-save]').addEventListener('click', () => saveConsent({
      preferences: preferencesInput.checked,
      analytics: analyticsInput.checked,
      marketing: marketingInput.checked
    }));
    root.querySelectorAll('[data-hibana-open-preferences], [data-hibana-close]').forEach((trigger) => {
      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        if (trigger.hasAttribute('data-hibana-close')) closePreferences();
        else openPreferences();
      });
    });

    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error || !window.Shopify.customerPrivacy) {
        status.textContent = root.dataset.consentError;
        root.querySelectorAll('button').forEach((button) => { button.disabled = true; });
        showBanner();
        return;
      }
      consentApiReady = true;
      const consent = window.Shopify.customerPrivacy.currentVisitorConsent();
      currentConsent = consent;
      hasDecision = ['preferences', 'analytics', 'marketing'].some((key) => consent[key] !== '');
      syncControls(consent);
      applyConsent(consent);
      if (hasDecision) hideBanner();
      else showBanner();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hibana-cookie-consent"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.getElementById('hibana-cookie-consent');
    if (!root || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

    const banner = root.querySelector('[data-hibana-banner]');
    const dialog = root.querySelector('[data-hibana-dialog]');
    const modalToggle = root.querySelector('[data-hibana-modal-toggle]');
    const status = root.querySelector('[data-hibana-status]');
    const preferencesInput = root.querySelector('[data-hibana-preferences]');
    const analyticsInput = root.querySelector('[data-hibana-analytics]');
    const marketingInput = root.querySelector('[data-hibana-marketing]');
    const gtmId = root.dataset.gtmId;
    let hasDecision = false;
    let gtmLoaded = false;
    let consentApiReady = false;
    let currentConsent = { preferences: '', analytics: '', marketing: '' };

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('consent', 'default', {
      ad_storage: 'denied',
      ad_user_data: 'denied',
      ad_personalization: 'denied',
      analytics_storage: 'denied',
      functionality_storage: 'denied',
      personalization_storage: 'denied',
      security_storage: 'granted',
      wait_for_update: 500
    });

    const loadGtm = () => {
      if (gtmLoaded || !gtmId) return;
      gtmLoaded = true;
      window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`;
      document.head.appendChild(script);
    };

    const applyConsent = (consent) => {
      const preferencesGranted = consent.preferences === true || consent.preferences === 'yes';
      const analyticsGranted = consent.analytics === true || consent.analytics === 'yes';
      const marketingGranted = consent.marketing === true || consent.marketing === 'yes';
      window.gtag('consent', 'update', {
        ad_storage: marketingGranted ? 'granted' : 'denied',
        ad_user_data: marketingGranted ? 'granted' : 'denied',
        ad_personalization: marketingGranted ? 'granted' : 'denied',
        analytics_storage: analyticsGranted ? 'granted' : 'denied',
        functionality_storage: preferencesGranted ? 'granted' : 'denied',
        personalization_storage: preferencesGranted ? 'granted' : 'denied',
        security_storage: 'granted'
      });
      window.dataLayer.push({
        event: 'hibana_consent_updated',
        hibana_preferences_consent: preferencesGranted,
        hibana_analytics_consent: analyticsGranted,
        hibana_marketing_consent: marketingGranted
      });
      if (analyticsGranted || marketingGranted) loadGtm();
    };

    const syncControls = (consent) => {
      preferencesInput.checked = consent.preferences === 'yes';
      analyticsInput.checked = consent.analytics === 'yes';
      marketingInput.checked = consent.marketing === 'yes';
    };

    const showBanner = () => {
      banner.hidden = false;
    };

    const hideBanner = () => {
      banner.hidden = true;
    };

    const openPreferences = () => {
      if (!consentApiReady) return;
      syncControls(currentConsent);
      banner.hidden = true;
      status.textContent = '';
      modalToggle.checked = true;
    };

    const closePreferences = () => {
      modalToggle.checked = false;
      if (hasDecision) hideBanner();
      else showBanner();
    };

    const saveConsent = (consent) => {
      if (!consentApiReady) return;
      status.textContent = '';
      window.Shopify.customerPrivacy.setTrackingConsent(consent, () => {
        hasDecision = true;
        currentConsent = consent;
        applyConsent(consent);
        modalToggle.checked = false;
        hideBanner();
      });
    };

    const acceptAll = () => saveConsent({ preferences: true, analytics: true, marketing: true });
    const rejectOptional = () => saveConsent({ preferences: false, analytics: false, marketing: false });

    root.querySelector('[data-hibana-accept]').addEventListener('click', acceptAll);
    root.querySelector('[data-hibana-dialog-accept]').addEventListener('click', acceptAll);
    root.querySelector('[data-hibana-reject]').addEventListener('click', rejectOptional);
    root.querySelector('[data-hibana-dialog-reject]').addEventListener('click', rejectOptional);
    root.querySelector('[data-hibana-save]').addEventListener('click', () => saveConsent({
      preferences: preferencesInput.checked,
      analytics: analyticsInput.checked,
      marketing: marketingInput.checked
    }));
    root.querySelectorAll('[data-hibana-open-preferences], [data-hibana-close]').forEach((trigger) => {
      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        if (trigger.hasAttribute('data-hibana-close')) closePreferences();
        else openPreferences();
      });
    });

    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error || !window.Shopify.customerPrivacy) {
        status.textContent = root.dataset.consentError;
        root.querySelectorAll('button').forEach((button) => { button.disabled = true; });
        showBanner();
        return;
      }
      consentApiReady = true;
      const consent = window.Shopify.customerPrivacy.currentVisitorConsent();
      currentConsent = consent;
      hasDecision = ['preferences', 'analytics', 'marketing'].some((key) => consent[key] !== '');
      syncControls(consent);
      applyConsent(consent);
      if (hasDecision) hideBanner();
      else showBanner();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hibana-inventory-status-block"] && !Shopify.designMode) return;
  try {
    (function() {
    function readJson(root, selector, fallback) {
      const source = root.querySelector(selector);
      if (!source) return fallback;

      try {
        return JSON.parse(source.textContent);
      } catch (error) {
        return fallback;
      }
    }

    function getVariantId(root) {
      const productInfo = root.closest('.t4s-product__info-container');
      const productFormInput = productInfo?.querySelector('form[action*="/cart/add"] [name="id"]')
        || document.querySelector('form[action*="/cart/add"] [name="id"]');

      if (productFormInput && productFormInput.value) {
        return String(productFormInput.value);
      }

      const url = new URL(window.location.href);
      return url.searchParams.get('variant');
    }

    function resolveStatus(variant, override, lowStockThreshold) {
      if (override && override !== 'auto') {
        return override;
      }

      if (!variant) {
        return 'not_available';
      }

      const quantity = Number(variant.inventory_quantity || 0);

      if (!variant.inventory_management) {
        return 'in_stock';
      }

      if (quantity > 0) {
        if (quantity <= lowStockThreshold) {
          return 'low_stock';
        }

        return 'in_stock';
      }

      if (variant.inventory_policy === 'continue') {
        return 'pre_order';
      }

      if (variant.available) {
        return 'in_stock';
      }

      return 'out_of_stock';
    }

    function init(root) {
      if (root.dataset.hibanaInventoryInitialized === 'true') return;

      const variantData = readJson(root, '[data-hibana-inventory-variants]', []);
      const copy = readJson(root, '[data-hibana-inventory-copy]', {});
      const label = root.querySelector('.hibana-inventory-status__label');
      const message = root.querySelector('.hibana-inventory-status__message');
      const override = root.dataset.statusOverride || 'auto';
      const lowStockThreshold = Number(root.dataset.lowStockThreshold || 5);
      let lastVariantId = null;

      function update() {
        const variantId = getVariantId(root);
        const variant = variantData.find((item) => String(item.id) === String(variantId)) || variantData[0];
        const status = resolveStatus(variant, override, lowStockThreshold);

        if (String(variantId) === String(lastVariantId) && status === root.dataset.currentStatus) {
          return;
        }

        const content = copy[status] || copy.not_available;
        if (!content) return;

        lastVariantId = variantId;
        root.dataset.currentStatus = status;
        root.style.setProperty('--hibana-stock-current', content.color);
        if (label) label.textContent = content.label;
        if (message) message.textContent = content.message;
      }

      update();
      document.addEventListener('change', update);
      document.addEventListener('variant:change', update);
      document.addEventListener('product:variant-change', update);
      window.setInterval(update, 500);
      root.dataset.hibanaInventoryInitialized = 'true';
    }

    function initAll() {
      document.querySelectorAll('.hibana-inventory-status').forEach(init);
    }

    initAll();
    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', initAll);
  })();
  } catch(e) { console.error(e); }
})();

})();
